import PatientProfileForm from './PatientProfileForm';

export default PatientProfileForm;
